export const LANGUAGES = {
    "es": "Español",
    "en": "Ingles",
};